<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" :before-query-search="beforeQuerySearch" res="page" @afterFetchOriginalData="afterFetchOriginalData" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.spuCode')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.spuCode')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockChange.header.categoryId')" prop="categoryId">
            <BjGoodsTypeTreeSelect v-model="queryParams.categoryId" :placeholder="$t('BusinessStockChange.header.categoryId')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockChange.header.warehouseCode')" prop="warehouseCode">
            <BjInput v-model="queryParams.warehouseCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockChange.header.warehouseCode')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockChange.header.warehouseName')">
            <BjSelectWarehouse v-model="queryParams.warehouseCode" :placeholder="$t('BusinessStockChange.header.warehouseName')" value-code="code" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockChange.header.recordTypeMeaning')" prop="recordTypeCodeList">
            <BjSelectLov v-model="queryParams.recordTypeCodeList" :placeholder="$t('BusinessStockChange.header.recordTypeMeaning')" multiple lov-code="STOCK.RECORD_TYPE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockChange.header.warehouseType')" prop="warehouseTypeCodeList">
            <BjSelectLov v-model="queryParams.warehouseTypeCodeList" :placeholder="$t('BusinessStockChange.header.warehouseType')" multiple lov-code="STOCK.WAREHOUSE_TYPE" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:seniorForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.order')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessStockChange.header.changeTime')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockChange.header.recordCode')" prop="recordCode">
            <BjInput v-model="queryParams.recordCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockChange.header.recordCode')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableOperation>
        <!-- <el-col>
          <el-tag effect="plain">入库数：({{ totalData.putNum || 0 }})</el-tag>
          <el-tag effect="plain">出库数：({{ totalData.outNum || 0 }})</el-tag>
          <el-tag effect="plain">差异数：({{ totalData.differenceNum || 0 }})</el-tag>
        </el-col> -->
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'code'" class="link" @click="onView(scope.row)">
                {{ scope.row[col.prop] }}
              </span>
              <template v-else-if="col.prop === 'status'">
                {{ $t(STOCK_LOCK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <!--
                状态：

待审核，该记录可作废

已审核，该记录可停用

已作废，该记录不可操作

停用，该记录可启用(前提条件生效时间没失效)
               -->
              <el-button :disabled="scope.row.status !== 'success'" type="text" @click="onStatus('close', scope.row)">{{ $t('disableText') }}</el-button>
              <el-button :disabled="scope.row.status !== 'close'" type="text" @click="onStatus('wait', scope.row)">{{ $t('enableText') }}</el-button>
              <el-button :disabled="scope.row.status !== 'wait'" type="text" @click="onStatus('abandon', scope.row)">{{ $t('BusinessStockChange.voidBtn') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <!-- <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" /> -->
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
// import DataForm from './components/DataForm.vue';
import { STOCK_LOCK_STATUS_LIST } from '@/utils/constants';
export default {
  name: 'BusinessStockChange',
  components: {
    // DataForm,
  },
  mixins: [pageMiXin],

  data() {
    return {
      colSpan: 4,
      STOCK_LOCK_STATUS_LIST,
      queryApi: stockApi.getChangeRecords,
      // 查询参数
      queryParams: {
        beginDate: null,

        endDate: null,

        recordTypeCodeList: [],
        categoryId: null,
        skuCode: null,
        // sort: {},
        spuCode: null,
        spuName: null,
        warehouseCode: null,
        warehouseName: null,
        warehouseTypeCodeList: [],
        recordCode: null,
      },

      labelList: [
        // {
        //   label: 'goodsPage.spuCode',
        //   prop: 'spuCode',
        //   isCheck: true,
        //   disabled: false,
        //   width: 160,
        // },
        // {
        //   label: 'goodsPage.spuName',
        //   prop: 'spuName',
        //   isCheck: true,
        //   disabled: false,
        //   width: 160,
        // },
        {
          label: 'BusinessStockChange.table.skuCode',
          prop: 'skuCode',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: 'BusinessStockChange.table.categoryName',
          prop: 'categoryName',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: 'BusinessStockChange.table.warehouseCode',
          prop: 'warehouseCode',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: 'BusinessStockChange.table.warehouseName',
          prop: 'warehouseName',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: 'BusinessStockChange.table.recordTypeMeaning',
          prop: 'recordTypeMeaning',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: 'BusinessStockChange.table.warehouseTypeMeaning',
          prop: 'warehouseTypeMeaning',
          isCheck: true,
          disabled: false,
          width: '135',
        },
        {
          label: 'BusinessStockChange.table.qtyTypeMeaning',
          prop: 'qtyTypeMeaning',
          isCheck: true,
          disabled: false,
          width: '135',
        },
        {
          label: 'BusinessStockChange.table.preRealNum',
          prop: 'preRealNum',
          isCheck: true,
          disabled: false,
          width: '200',
        },
        {
          label: 'BusinessStockChange.table.changeNum',
          prop: 'changeNum',
          isCheck: true,
          disabled: false,
          width: '190',
        },
        {
          label: 'BusinessStockChange.table.aftRealNum',
          prop: 'aftRealNum',
          isCheck: true,
          disabled: false,
          width: '190',
        },
        {
          label: 'BusinessStockChange.table.recordCode',
          prop: 'recordCode',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: 'BusinessStockChange.table.operator',
          prop: 'createdName',
          isCheck: true,
          disabled: false,
          width: 135,
        },
        {
          label: 'BusinessStockChange.table.creationDate',
          prop: 'creationDate',
          isCheck: true,
          disabled: false,
          width: 135,
        },
      ],
      queryParamsTime: null,
      totalData: {},
    };
  },
  computed: {},
  watch: {
    queryParamsTime(v) {
      this.queryParams.beginDate = (v || [])[0];
      this.queryParams.endDate = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    afterFetchOriginalData(res) {
      // this.totalData = {
      //   differenceNum: res.differenceNum,
      //   outNum: res.outNum,
      //   putNum: res.putNum,
      // };
    },
    beforeQuerySearch(conditionObj) {
      return new Promise(resolve => {
        resolve(conditionObj);
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.STOCK_LOCK_STATUS_LIST.bjGet(flag);
      this.$confirm(
        `${this.$t('toast.youAreTipText')} ${TEXT} ${row.warehouseName}${this.$t(
          'BusinessStockChange.confirmText2',
        )}，${this.$t('toast.continueTipText')}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          this.operationApi({
            id: row.id,
            status: flag,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    // onDelete(row) {
    //   this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
    //     confirmButtonText: this.$t('toast.okText'),
    //     cancelButtonText: this.$t('toast.cancelText'),
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.batchDeleteApi(row);
    //     })
    //     .catch(() => {});
    // },
    // /** 批量删除操作 */
    // onDeleteSelected() {
    //   if (!this.selectedRows.length) {
    //     this.$message.warning(this.$t('chooseText'));
    //     return;
    //   }
    //   const ids = this.selectedRows.map(e => e.id);
    //   this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
    //     confirmButtonText: this.$t('toast.okText'),
    //     cancelButtonText: this.$t('toast.cancelText'),
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.batchDeleteApi({ ids: ids });
    //     })
    //     .catch(() => {});
    // },
    /** 新建 */
    onAdd() {
      this.$toPage('BusinessStockLockAdd');
      // this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      // this.$refs.DataForm.show(this.$lodash.clone(row));
    },
    /** 查看 */
    onView(row) {
      this.$toPage('BusinessStockLockView', { id: row.id });
      // this.$refs.DataForm.show();
    },
    operationApi(API_DATA) {
      stockApi.statusReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // deleteApi(API_DATA) {
    //   stockApi.deleteOnlineShop(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    batchDeleteApi(API_DATA) {
      stockApi.detailReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tag {
  margin-right: 10px;
}
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
